import LayoutAdmin from "Admin/Layout/Layout";
import LayoutBenchmarking from "Benchmarking/Layout/Layout";
import LayoutExplore from "Explore/Layout/Layout";
import LandingPage from "LandingPage/Layout/Layout";
import Login from "LandingPage/Pages/Login/Login";
import ResetPassword from "LandingPage/Pages/ResetPassword/ResetPassword";
import ProtectedRoute from "ProtectedRoute";
import { createBrowserRouter } from "react-router-dom";
import LayoutSuperAdmin from "SuperAdmin/Layout/Layout";

const router = createBrowserRouter([
  {
    path: "/login",
    element: <Login />,
    index: true,
  },
  {
    path: "/reset-password",
    element: <ResetPassword />,
    index: true,
  },
  {
    path: "/",
    element: <LandingPage />,
    index: true,
  },
  {
    path: "/explore/*",
    element: <LayoutExplore />,
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        path: "/super-admin/*",
        element: <LayoutSuperAdmin />,
      },
      {
        path: "/admin/*",
        element: <LayoutAdmin />,
      },
      {
        path: "/benchmarking/*",
        element: <LayoutBenchmarking />,
      },
    ],
  },
  {
    path: "*",
    element: <p>404 Error - Nothing here...</p>,
  },
]);

export default router;
